<template>
  <div class="informationDisclosure">
    <z-fix-top
      v-if="isShowHead"
      ref="fixtop"
      keep-position
      class="fixtop"
      :style="{background: '#F7F7F7'}"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          :title="navTitle"
          @click-left="handleClickLeft"
      >
      </z-nav-bar>
    </z-fix-top>
    <div class="content">
      <div class="title">
        您是否因为以下交易订单纠纷导致本人权益受损，申请平台披露交易另一方用户相关资料？
      </div>
      <ProductCard/>
    </div>
    <z-button-group class="bottom-button">
      <z-button type="primary" @click="submitNext">确认订单，我要申请</z-button>
    </z-button-group>
  </div>
</template>

<script>
import { NavBar, FixTop, Button, ButtonGroup, Dialog } from '@zz-common/zz-ui';
import { queryParams, getCookie } from '@lib/utils'
import ProductCard from '../Components/productCard.vue';
import { doCheckBeforeDisclosure } from '@api/resourceApi'
import native from '@zz-common/native-adapter';

const query = queryParams()

export default {
  name: 'InformationDisclosureConfirm',
  data() {
    return {
      navTitle: '确认订单',
      uid: getCookie('uid'),
      orderId: query.orderId || this.$route.query.orderId || '',
      from: query.from || this.$route.query.from || '',
      isNeedAutoSkip: false, //用于判断回到当前页面是否自动进入下一个页面，认证完自动进入，用户回退不进入
      isShowHead: true
    }
  },
  components: {
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar,
    'z-button-group': ButtonGroup,
    'z-button': Button,
    ProductCard
  },
  methods: {
    handleClickLeft() {
      native.close()
    },
    showIntercept(data) {
      const { punishDesc, punishTitle } = data
      let { retButtons } = data
      let confirm = {}
      let cancel = {}
      const dialogParams = {
        title: punishTitle,
        message: punishDesc
      }
      try {
        if (retButtons) {
          retButtons = JSON.parse(retButtons)
        }
      } catch {}
      const buttonLength = (retButtons || []).length;
      //单按钮逻辑
      if (buttonLength == 1) {
        confirm = retButtons[0]
        dialogParams.confirmButtonText = retButtons[0].buttonDesc
      }
      //双按钮逻辑
      if (buttonLength == 2) {
        cancel = retButtons[0]
        dialogParams.showCancelButton = true
        dialogParams.cancelButtonText = retButtons[0].buttonDesc
        confirm = retButtons[1]
        dialogParams.confirmButtonText = retButtons[1].buttonDesc
      }
      Dialog(dialogParams)
        .then(() => {
          this.isNeedAutoSkip = true;
          const type = confirm.type
          if (type == 0) {
            native.close()
          }
          if (type == 1) {
            native.skipToUrl({
              targetUrl: confirm.mUrl,
              needClose: '0'
            })
          }
        })
        .catch(() => {
          const type = cancel.type
          if (type == 0) {
            native.close()
          }
          if (type == 1) {
            native.skipToUrl({
              targetUrl: cancel.mUrl,
              needClose: '0'
            })
          }
        })
    },
    submitDisclosure() {
      const params = {
        uid: this.uid,
        orderId: this.orderId,
        form: this.from
      }
      doCheckBeforeDisclosure(params).then((res) => {
        const { msg } = res;
        if (msg == 'OK') {
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/informationDisclosure/commit?from=${this.from}&orderId=${this.orderId}`,
            needClose: '0'
          })
        } else {
          this.showIntercept(res)
        }
      })
    },
    submitNext() {
      this.isNeedAutoSkip = false;
      this.submitDisclosure();
    },
    handleVisiable(e) {
      if (e.target.visibilityState === 'visible' && this.isNeedAutoSkip) {
        this.isNeedAutoSkip = false; //自动跳转消耗掉后用户手动回退时就不会自动跳了
        this.submitDisclosure()
      }
    }
  },
  mounted() {
    if (native.in('miniprogram')) {
      this.isShowHead = false
    }
    native.setTitle({
      title: '确认订单'
    })
    document.addEventListener('visibilitychange', this.handleVisiable)
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisiable)
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
